<article>
	<header class="page-header">
		<div class="breadcrumb-line">
			<stages-breadcrumb [links]="true" [path]="breadcrumb"></stages-breadcrumb>
			@if (self) {
				<stages-process-version [type]="self.type?.ident" [identity]="self.identity"></stages-process-version>
			}
		</div>
		@if (self) {
			<stages-element-name [self]="$any(self)"></stages-element-name>
		}
	</header>

	<div class="container row">
		<div class="container column col-12">
			<ng-container stagesSlot="top"></ng-container>
		</div>
	</div>
</article>
